export const REVEAL_DROPDOWN_MAX_ITEM = 1_300;
export const NO_TOUCH_USER_REVEAL_DROPDOWN_MAX_ITEM = 500;

export const REVEAL_DROPDOWN_ITEMS_LIST = [50, 100, 250, 500, 1_000, REVEAL_DROPDOWN_MAX_ITEM];
export const NO_TOUCH_USER_REVEAL_DROPDOWN_ITEMS_LIST = [10, 25, 50, 250, NO_TOUCH_USER_REVEAL_DROPDOWN_MAX_ITEM];
